module.exports = __webpack_public_path__ + "img/zzcx.a997d915.png";